import { LmmBenodigdOpbouw } from '../types/LmmVoorraad';

export const getLmmClaimsTotaal = (benodigd: LmmBenodigdOpbouw): number => benodigd.gdst + benodigd.ebksb;
